<template>
  <paginate
    v-model="currentPage"
    :page-count="count"
    :click-handler="handleClick"
    :page-range="5"
    :prev-text="''"
    :next-text="''"
    :prev-link-class="'icon-button-arrow left'"
    :next-link-class="'icon-button-arrow right'"
    :container-class="'pagination a-hover'"
  >
  </paginate>
</template>

<script>
import Paginate from "vuejs-paginate";

export default {
  name: "Pagination",
  components: { Paginate },
  props: {
    count: { type: Number, default: 1 },
  },
  watch: {
    "$route.query.page": function (page) {
      this.page = parseInt(page) || 1;
    },
  },
  data() {
    return {
      page: parseInt(this.$route.query.page) || 1,
    };
  },
  computed: {
    currentPage: {
      get() {
        return parseInt(this.page);
      },
      set(value) {
        this.page = parseInt(value);
      },
    },
  },
  methods: {
    handleClick(page) {
      const currentPage = parseInt(this.page);
      let newPage;

      if (page === "next") {
        newPage = currentPage + 1;
      } else if (page === "prev") {
        newPage = currentPage - 1;
      } else {
        newPage = parseInt(page);
      }

      if (isNaN(newPage) || newPage < 1 || newPage > this.count) return;

      let newQuery = Object.assign({}, this.$route.query, { page: newPage });
      if (newPage === 1) delete newQuery.page;
      this.$router.push({ path: this.$route.path, query: newQuery });
    },
  },
};
</script>

<style>
.pagination {
  grid-column: 1 / -1;
  margin-top: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  user-select: none;
}

.pagination li {
  margin: 0 0.5rem;
}

.pagination a {
  outline: 0;
  display: block;
}

.pagination li.active a {
  color: var(--accent);
}

.VuePagination__count {
  display: none;
}

.pagination .disabled {
  pointer-events: none;
  opacity: 0.2;
}
</style>
